module.exports = __webpack_public_path__ + "img/ssyx_25.ace17133.jpg";